// components/ActivityShowcaseSlider.jsx

import React, { useEffect, useState } from 'react'
import { Swiper, SwiperSlide } from 'swiper/react'
import Link from 'next/link'
import { EffectCoverflow, Autoplay, Pagination, Navigation } from 'swiper'
import { Box } from '@mui/material'
import 'swiper/css'
import 'swiper/css/effect-coverflow'
import 'swiper/css/pagination'
import 'swiper/css/autoplay'

import styles from './SupplierSlide.module.scss'

const TypeMap = {
  4: 'Staycation',
  6: 'Activity',
  // 7: 'Bus',
  8: 'Holiday'
}

const items = [
  // {
  //   title: 'Flight',
  //   image: '/images/userwebsite/supplier/flight.png',
  //   type: 1,
  //   link: '/flights'
  // },
  // {
  //   title: 'Hotels',
  //   image: '/images/userwebsite/supplier/hotels.png',
  //   type: 2,
  //   link: '/hotels'
  // },
  // {
  //   title: 'Visa',
  //   image: '/images/userwebsite/supplier/visa.png',
  //   type: 3,
  //   link: '/visa-service/0'
  // },
  {
    title: 'Activities',
    image: '/images/userwebsite/supplier/activities.jpg',
    type: 4,
    link: '/activities/activities?cityName=All&name=&destinationName=All&productId='
  },
  {
    title: 'Staycation',
    image: '/images/userwebsite/supplier/staycation.jpg',
    type: 5,
    link: '/staycation/staycations?cityName=All&name=&checkIn=&checkOut=&productId='
  },
  {
    title: 'Holidays',
    image: '/images/userwebsite/supplier/holidays.jpg',
    type: 6,
    link: '/holidays/holidays?country=&cityName=All&name=&adult=1&child=0&rooms=1&productId='
  }
]

const ActivityShowcaseSlider = () => {
  const [activeIndex, setActiveIndex] = useState(0)
  const [filteredActivities, setFilteredActivities] = useState(items)

  return (
    <div
      style={{
        padding: '20px 0'
      }}
      className='rsl__Wrapper_invest'
    >
      <Swiper
        spaceBetween={16}
        pagination={{ clickable: true }}
        modules={[Pagination, Navigation, Autoplay]}
        autoplay={{ delay: 3000 }}
        speed={2000}
        style={{ paddingBottom: '30px' }} // 👉 Reduce bottom padding also
        onSlideChange={swiper => {
          setActiveIndex(swiper.realIndex)
        }}
        breakpoints={{
          0: {
            slidesPerView: 1 // mobile
          },
          600: {
            slidesPerView: 1 // tablet
          },
          960: {
            slidesPerView: 3 // small desktop
          },
          1280: {
            slidesPerView: 3 // full desktop
          }
        }}
        navigation
        grabCursor={true}
        // loop={true}
        className='activitySliderWrapper'
      >
        {filteredActivities.map((activity, index) => {
          const isActive = index === activeIndex
          return (
            <SwiperSlide
              key={activity.type}
              style={{
                width: isActive ? '500px' : '300px',
                height: '500px', // 👉 Increase height (was 400px earlier)
                borderRadius: '20px',
                overflow: 'hidden',
                transition: 'all 0.3s ease'
                // transform: isActive ? 'scale(1)' : 'scale(0.9)'
              }}
            >
              <Link
                href={activity.link}
                target='_blank'
                style={{
                  width: '100%',
                  height: '100%',
                  display: 'block',
                  position: 'relative'
                }}
              >
                <img
                  src={`${process.env.IMAGE_BASE_URL}${activity?.image}`}
                  alt={activity?.name}
                  style={{
                    width: '100%',
                    height: '100%',
                    objectFit: 'cover'
                  }}
                />
                <Box
                  sx={{
                    position: 'absolute',
                    bottom: 0,
                    left: 0,
                    right: 0,
                    background:
                      'linear-gradient(to top, rgba(0, 191, 165, 0.9), rgba(0, 191, 165, 0))',
                    color: 'white',
                    textAlign: 'center',
                    fontWeight: 'bold',
                    fontSize: '22px',
                    padding: '10px'
                  }}
                >
                  {activity?.title}
                </Box>
              </Link>
            </SwiperSlide>
          )
        })}
      </Swiper>
    </div>
  )
}

export default ActivityShowcaseSlider
